/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/LoadingSpinner';
import { Context } from 'components/Store';
import {
  EmptyProperties,
  PanelHeader,
  PropertyTreeView
} from '../components/PanelComponents';
import PropertyFilters from '../components/PropertyTreeView/components/PropertyFilters';
import PanelFooter from '../components/PanelFooter';
import PropertyLandingContext from '../context';

const propertiesTreeDefaultPropProperties = [];
const propertiesTreeDefaultPropRawProperties = [];
const PropertiesTree = ({
  properties = propertiesTreeDefaultPropProperties,
  rawProperties = propertiesTreeDefaultPropRawProperties,
  openCreateModal,
  memberRole,
  reloadProperties = null
}) => {
  const {
    isLoadingProperties,
    viewMode,
    financialAccess,
    fetchProperties,
    onViewModeChange
  } = useContext(PropertyLandingContext);
  const [{ searchTextValueFFT }] = useContext(Context);
  const [filtersOpen, setFiltersOpen] = useState(false);

  const onOpenFilters = () => setFiltersOpen(true);
  const onCloseFilters = () => setFiltersOpen(false);

  return (
    <div
      data-testid="property-landing-property-tree"
      className="h-full bg-white cursor-default flex flex-col outline-r outline-neutral-20"
    >
      {filtersOpen ? (
        <PropertyFilters properties={rawProperties} onClose={onCloseFilters} />
      ) : (
        <>
          <PanelHeader
            showTools={!!properties?.length || !!searchTextValueFFT?.valueInput}
            title="Properties"
            reloadFarmData={fetchProperties}
            openCreateModal={openCreateModal}
            openFilters={onOpenFilters}
            loading={isLoadingProperties}
            onChangeView={onViewModeChange}
            view={viewMode}
          />

          {isLoadingProperties && (
            <LoadingSpinner message="" label="Loading properties" />
          )}
          {!isLoadingProperties && properties?.length > 0 && (
            <PropertyTreeView properties={properties} />
          )}
          {!isLoadingProperties &&
            !properties?.length &&
            !searchTextValueFFT?.valueInput && (
              <EmptyProperties
                openCreateModal={openCreateModal}
                memberRole={memberRole}
                memberFinancialAccess={financialAccess}
              />
            )}

          <PanelFooter
            showTools={!!properties?.length}
            reloadFarmData={reloadProperties ?? fetchProperties}
            openCreateModal={openCreateModal}
            setView={onViewModeChange}
          />
        </>
      )}
    </div>
  );
};

PropertiesTree.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.object),
  rawProperties: PropTypes.arrayOf(PropTypes.object),
  openCreateModal: PropTypes.func.isRequired,
  memberRole: PropTypes.string.isRequired,
  reloadProperties: PropTypes.func
};

export default PropertiesTree;
